module.exports = __webpack_public_path__ + "img/qx_icon7.6c659bf9.png";